import { Locale } from "@/Common/Models/Localization/Locale";
import { BritishColumbiaObstetricalFileClickableTextContext } from "@/Common/Models/UI/ClickableTextContext";
import { BaseObstetricalFileClickableText, IBaseObstetricalFileClickableTextProps } from "./BaseObstetricalFileClickableText";

class BritishColumbiaObstetricalFileClickableText extends BaseObstetricalFileClickableText<IBaseObstetricalFileClickableTextProps> {
    public componentDidMount(): void {
        cacheStore.RequestApplicationStringAsync(Locale.en);
    }

    public render(): JSX.Element {
        if (!cacheStore.AreTranslationsLoaded(Locale.en))
            return null;

        return (
            <div>
                {this.renderSection(
                    cacheStore.GetString("ObstetricalFile_BritishColumbiaPart1Label"),
                    <tbody>
                        {this.renderClickableTextRow(cacheStore.GetString("ObstetricalFile_CommentsFollowUpLabel", null, Locale.en), BritishColumbiaObstetricalFileClickableTextContext.Section11_CommentsFollowup)}
                    </tbody>
                )}
                {this.renderSection(
                    cacheStore.GetString("ObstetricalFile_BritishColumbiaPart2Label"),
                    <tbody>
                        {this.renderClickableTextRow(cacheStore.GetString("ObstetricalFile_OtherLabel", null, Locale.en), BritishColumbiaObstetricalFileClickableTextContext.Section13_OtherTests)}
                        {this.renderClickableTextRow(cacheStore.GetString("ResultsLabel", null, Locale.en), BritishColumbiaObstetricalFileClickableTextContext.Section13_PrenatalInvestigationResult)}
                        {this.renderClickableTextRow(cacheStore.GetString("CommentsLabel", null, Locale.en), BritishColumbiaObstetricalFileClickableTextContext.Section17_SubsequentVisitComment)}
                    </tbody>
                )}
            </div>
        );
    }
}

export { BritishColumbiaObstetricalFileClickableText };
